import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import { createPinia } from 'pinia'
import InvasiveServiceInfo from 'src/components/common/InvasiveServiceInfo/InvasiveServiceInfo.vue'

export default function getInvasiveServiceInfoInstance() {
  const mountElement = document.querySelector('.vue-invasive-service-info-mount')

  return mountElement
    ? new Vue({
      vuetify,
      el: mountElement,
      pinia: createPinia(),
      render: h => h(InvasiveServiceInfo),
    })
    : null
}
